'use client'
import { Modal, type ModalProps } from '../modal.tsx'
import {
  ConfirmationModalButton,
  ConfirmationModalCancelButton,
  ConfirmationModalConfirmButton,
} from './confirmation-modal-button.tsx'
import { ConfirmationModalFooter } from './confirmation-modal-footer.tsx'
import { ConfirmationModalHeader } from './confirmation-modal-header.tsx'
import { ConfirmationModalText } from './confirmation-modal-text.tsx'

type ConfirmationModalProps = Readonly<
  ModalProps & {
    onConfirm: () => void
    title?: string
  }
>

const ConfirmationModalComponent = ({
  children,
  onClose,
  onConfirm,
  title,
  ...rest
}: ConfirmationModalProps) => {
  return (
    <Modal onClose={onClose} suppressUserClose {...rest}>
      <Modal.Dialog className="w-120">
        <Modal.Close />
        {children}
      </Modal.Dialog>
    </Modal>
  )
}

const ConfirmationModalNamespace = Object.assign(ConfirmationModalComponent, {
  Button: ConfirmationModalButton,
  CancelButton: ConfirmationModalCancelButton,
  ConfirmButton: ConfirmationModalConfirmButton,
  Content: ConfirmationModalText,
  Footer: ConfirmationModalFooter,
  Header: ConfirmationModalHeader,
})

export {
  ConfirmationModalNamespace as ConfirmationModal,
  type ConfirmationModalProps,
}
